// @vendors
import {
  createContext, 
  useEffect, 
  useMemo, 
  useReducer, 
  useState,
} from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import SwipeableViews from '@gromy/react-swipeable-views';

// @material-ui
import {
  Container, 
  Paper, 
  Step, 
  StepLabel,
  Stepper,
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';

// @state
import { useUI } from '../../../app/context/ui';
import { createEmployerReducer, initialState } from './state';
import store from '../../../redux/store';

// @assets
import { CreateEmployerStyles } from '../../../assets/css/createEmployer-style';

// @helpers
import AppHelper from '../../../helpers/AppHelper';
import { authForSuperAdmin } from '../../../helpers/GetTokenNewApi';
import { LISTROLES } from '../../../helpers/ListRoles';

// @components
import FirstForm from './components/FirstForm';
import SecondForm from './components/SecondForm';

// @service
import CompanyServiceNewApi from '../../../services/newApi/CompanyServiceNewApi';
import { ROUTENAME } from '../../../navigation/RouteName';

const steps = ['', ''];

const CreateEmployer = ({ id }) => {
  const [state, dispatch] = useReducer(createEmployerReducer, initialState);
  const { firstFormValues, secondFormValues } = state;
  const history = useHistory();
  const [activeStep, setActiveStep] = useState(0);
  const { blockUI, dialogUI, snackbarUI } = useUI();
  const styles = useMemo(() => CreateEmployerStyles(), []);
  const addCompanyService = useMemo(() => new CompanyServiceNewApi(),[]);
  const user = store.getState()
  const dispatchClient = useDispatch()
  const location = useLocation();
  const dataCompany = location.state?.data;
  const parentId = location.state?.parentCompanyId ?? '';
  const globalState = useSelector((state) => state.organizationReducer.organizationSelected);
  const [isBtnDisabled, setIsBtnDisabled] = useState(false);

  useEffect(() => {
    if(dialogUI?.current === null)window.location.reload()
    if(window.scrollY)window.scroll(0, 0);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleStepDirection = (e, direction) => {
    if (direction === 'back') {
      setActiveStep((prev) => prev - 1);
      return;
    }
    window.scroll(0,0)
    if (activeStep === 0) setActiveStep((prev) => prev + 1);
  };

  const handleStepChange = (value, index) => {
    setActiveStep(index);
  };

  const onSubmit = async () => {
    setIsBtnDisabled(true);
    let payload = { ...firstFormValues, ...secondFormValues };
    const INFO = dataToSend(payload);
    const settings = {
      confirm: true,
      btn: {
        confirm: 'Close',
        close: ''
      },
      onConfirm: () => {
        dialogUI.current.close();
        state.firstFormValues.name
          ? history.goBack()
          : history.push(ROUTENAME.dashboard);
      },
      styles: { ...styles.dialog }
    };
    sendDataEmployeer(INFO, settings)
  };

  const getBooleanValue = (value) => {
    if(value === 'true' || value === true) return true
    return false
  }

  const isAxiscare = (value) => {
    const isRocker = globalState?.name?.toLowerCase();
    if(isRocker === 'rockerbox')return getBooleanValue(value);
    return null;
  }
  
  const isAxiscareField = (value) => {
    const isRocker = globalState?.name?.toLowerCase();
    if(isRocker === 'rockerbox')return value;
    return null;
  }

  const dataToSend = (payload) => {
    const DATA = {
      name: payload?.name,
      tradeName: payload?.tradeName ? payload?.tradeName : null,
      fein: payload?.fein,
      address: payload?.address,
      city: payload?.city,
      county: payload?.county,
      state: payload?.state,
      stateId: payload?.stateId,
      emails: payload?.lEmails,
      zipCode: payload?.zipCode,
      payrollContactName: payload?.payrollContactName ? payload?.payrollContactName : null,
      payrollContactEmail: payload?.payrollContactEmail ? payload?.payrollContactEmail : null,
      poaContact: payload?.poaContact ? payload?.poaContact : null,
      poaEmail: payload?.poaEmail ? payload?.poaEmail : null,
      wotcContact: payload?.wotcContact ? payload?.wotcContact : null,
      wotcEmail: payload?.wotcEmail ? payload?.wotcEmail : null,
      sponsor: payload?.sponsor ? payload?.sponsor : null,
      sponsorEmail: payload?.sponsorEmail ? payload?.sponsorEmail : null,
      status: payload?.status ? payload?.status : 'active',
      phoneNumber: payload?.phoneNumber,
      employerRate: payload?.employerRate ? payload?.employerRate : 0,
      sendEmailToEmployeeWhenCreated: getBooleanValue(payload?.sendEmailToEmployeeWhenCreated),
      isCountyOrCityManual: getBooleanValue(firstFormValues?.isCountyOrCityManual),
      isWebhookConfigured: getBooleanValue(payload?.isWebhookConfigured),
      webhookUrl: payload?.webhookUrl ? payload?.webhookUrl : null,
      webhookSecret: payload?.webhookSecret ? payload?.webhookSecret : null,
      externalCompanyId: payload?.externalCompanyId ? payload?.externalCompanyId : null,
      tiles: payload?.tiles,
      signatureResponsibleName8850Form: payload?.signatureResponsibleName8850Form ? payload?.signatureResponsibleName8850Form : null,
      signatureResponsibleTitle8850Form: payload?.signatureResponsibleTitle8850Form ? payload?.signatureResponsibleTitle8850Form : null,
      signatureResponsibleName9061Form: payload?.signatureResponsibleName9061Form ? payload?.signatureResponsibleName9061Form : null,
      rbAcctId: payload?.rbAcctId ? payload?.rbAcctId : null,
      displayName: payload?.displayName ? payload?.displayName : null,
      isAxiscare: isAxiscare(payload?.isAxiscare),
      site: isAxiscareField(payload?.site),
      agency: isAxiscareField(payload?.agency),
      hubspotId: payload?.hubspotId ? payload?.hubspotId : null,
      parentCompanyId: getParentCompanyId(payload?.parentCompanyId),
      payScheduleId: payload?.payScheduleId || null,
      sendWotcReminders: payload.sendWotcReminders,
      selectEmployeeStateHs: payload.selectEmployeeStateHs === null ? false : payload.selectEmployeeStateHs,
      sendSmsNotificationsForSurveys: payload.sendSmsNotificationsForSurveys,
      defaultOccupationId: payload.defaultOccupationId,
      isNonProfit: payload.isNonProfit
    }
    return DATA
  }

  const getParentCompanyId = (id) => {
    if(parentId)return parentId;
    if(id) return id;
    return null
  }

  const callListClients = (r2) => {
    const role = user?.user?.role;
    if (role && role === LISTROLES.superAdmin) {
      authForSuperAdmin(dispatchClient, snackbarUI, true);
    }
  };

  const sendDataEmployeer = (payload, settings) => {
    if (id) updateEmployer(payload, settings)
    else createEmployer(payload, settings)
  }

  const updateEmployer = async (payload, settings) => {
    try {
      blockUI.current.open(true);
      await addCompanyService.updateCompany(payload, id);
      openDialogUi(settings, 'updated')
      callListClients()
      blockUI.current.open(false);
      setIsBtnDisabled(false);
    } catch (error) {
      setIsBtnDisabled(false);
      blockUI.current.open(false);
      AppHelper.checkError(error, snackbarUI);
    }
  }

  const createEmployer = async (payload, settings) => {
    const organizationId = user?.organizationReducer?.organizationSelected?.id;
    try {
      blockUI.current.open(true);
      await addCompanyService.addCompany(payload, organizationId);
      openDialogUi(settings, 'created')
      callListClients()
      blockUI.current.open(false);
      setIsBtnDisabled(false);
    } catch (error) {
      setIsBtnDisabled(false);
      blockUI.current.open(false);
      AppHelper.checkError(error, snackbarUI);
    }
  }

  const openDialogUi = (settings, actionText) => {
    setTimeout(() => {
      blockUI.current.open(false);
      dialogUI.current.open('Great!', `Employer has been ${actionText} successfully.`, settings);    
    }, 100);
  }

  const contextProps = {
    state,
    dispatch,
    id,
    steps,
    activeStep,
    handleStepDirection,
    onSubmit,
    dataCompany,
    parentId,
    isBtnDisabled
  };

  return (
    <CompanyContext.Provider value={contextProps}>
      <Container
        component="section"
        maxWidth="xl"
        sx={styles.dashCtn}
      >
        <Paper elevation={5} sx={styles.paper}>
          <Stepper connector={null} activeStep={activeStep} sx={styles.stepper}>
            <Step>
              <StepLabel />
            </Step>
            <Step>
              <StepLabel />
            </Step>
          </Stepper>
          <SwipeableViews index={activeStep} onChangeIndex={handleStepChange} >
            <FirstForm />
            <SecondForm />
          </SwipeableViews>
        </Paper>
      </Container>
    </CompanyContext.Provider>
  );
};

export const CompanyContext = createContext({});
export default CreateEmployer;
